import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SeoService } from './_services/seo.service';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
    constructor(private seo: SeoService) {
        this.seo.setMetaFavIcon()
        this.seo.initBaseTags()
    }
}
